.head {
  grid-column: 1 / -1;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  gap: 10px 16px;
  min-width: 0;
}

.text {
  min-width: 0;
}

.title {
  margin: 0;
  font-size: var(--t-head);
  font-weight: 650;
  letter-spacing: -0.01em;
  line-height: 1.3;
}

.subtitle {
  margin: 2px 0 0;
  color: var(--muted);
  font-size: var(--t-dense);
  line-height: 1.4;
}

.side {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  min-width: 0;
}
